import React from "react";
import styles from "./box.module.scss";
const LightweightBox = ({ className = "", children }) => {
    return (React.createElement("div", { className: `${styles.vhvBox} ${className}` }, children));
};
export default LightweightBox;
